import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Keeps a Far & Away block in sync with the selected variant.
 *
 * The variant picker only re-renders itself; every other block has to pick its
 * new markup out of the section response. Blocks wrap their variant-dependent
 * markup in `<fa-refresh data-key="...">` and this element swaps in the
 * matching `<fa-refresh>` from the response.
 *
 * @extends {Component}
 */
class FaRefresh extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { key } = this.dataset;
        if (!key) return;

        const replacement = detail.html.querySelector(`fa-refresh[data-key="${CSS.escape(key)}"]`);
        if (!replacement) return;

        morph(this, replacement, { childrenOnly: true });
        // The element's own classes can carry state (e.g. fa-availability--low-stock), so they
        // follow the new variant too
        if (replacement.className !== this.className) this.className = replacement.className;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[fa-refresh] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('fa-refresh')) {
  customElements.define('fa-refresh', FaRefresh);
}
